import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import FeeRateCardNew from '../FeeRateCardNew';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Spinner,
  Input
} from "@material-tailwind/react";

import { BitcoinNetworkType, signMessage, signTransaction, sendBtcTransaction } from 'sats-connect';
import { useWallet, useWallets } from '@wallet-standard/react';
import toast, { Toaster } from 'react-hot-toast';
import { getDust20SafeTransferPsbt, getDust20FilterUtxos } from '../../util/dust20-api';
import { launchpadTokenRandom } from '../../util/new-api';
import { dust20TransferFee, ownerAddress } from '../../configs/constant';
import { getBtcUtxos } from '../../util/ordinal';
import logoImg from '../../assets/imgs/logo.png'

export default function SafeBtcTransferCard(props) {
  const { keyAddress } = props
  const { t, i18n } = useTranslation();
  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const feeRates = useSelector(state => state.feeRate);
  const wallet = useSelector(state => state.wallet);

  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(feeRates.Normal);
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState(0);
  const [address, setAddress] = useState('');
  const [available, setAvailable] = useState(0);
  const [utxos, setUtxos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAll, setIsAll] = useState(0);
  const [payLoading, setPayLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    const updateFees = async () => {
      if (feeRateMode == "Custom") {
        setFeerate(customFee);
      }
      else
      {
        setFeerate(feeRates[feeRateMode]);
        if (customFee == 0) 
        {
          setCustomFee(feeRates["Fast"] + 1);
        }
      }
    }

    updateFees();

  }, [feeRateMode, customFee, feeRates])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  const handleShow = async () => {
    setLoading(true);
    setShow(true);
    setErrorMessage('');
    setAddress('');
    setIsAll(0);
    setAmount(0);
    let tempUtxos = await getBtcUtxos(wallet.nostrPaymentAddress);
    let results = await getDust20FilterUtxos(tempUtxos);
    setUtxos(results);
    let sum = 0;
    for(let temp of results) {
      sum += temp.satoshis;
    }

    setAvailable(sum / Math.pow(10, 8));
    setLoading(false);
  }

  const handleHide = (e) => {
    e.preventDefault(false);
    setShow(false);
  }

  const handleSetIsAll = () => {
    setIsAll(1);
    setAmount(available);
  }

  const handlePay = async() => {
    setPayLoading(true);
    
    if (amount <= 0.00001 || isNaN(parseInt(amount))) {
      setErrorMessage(t('Insert Valid Amount Error Message'));
      setPayLoading(false);
      return;
    }
    else {
      setErrorMessage('');
    }

    if (address == '') {
      setErrorMessage(t('Insert Address Error Message'));
      setPayLoading(false);
      return;
    }
    else {
      setErrorMessage('');
    }

    let results = await launchpadTokenRandom(wallet.nostrOrdinalsAddress, 1) // dustzero
    let fundingAddress = ownerAddress;
    let fundingAmount = 0;
    if (results.data.length == 0) {
      fundingAmount = dust20TransferFee;
    }

    const paymentUtxos = await getDust20SafeTransferPsbt(utxos, address, amount, isAll, fundingAddress, fundingAmount, wallet.nostrPaymentAddress, wallet.paymentPublicKey, feerate, wallet.domain)

    let isSuccess = true;
    if (paymentUtxos.status == "fail") {
      setErrorMessage(t('Insufficient Balance Error Message'));
      setPayLoading(false);
      return;
    }

    try{
      if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: () => {
                setErrorMessage(t('Request canceled'));
                setPayLoading(false);
                isSuccess = false
                return;
            },
          });
  
        }
        else {
          setErrorMessage(t('Insufficient Balance Error Message'));
          setPayLoading(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => { 
            },
            onCancel: () => {
                setErrorMessage(t('Request canceled'));
                setPayLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          setErrorMessage(t('Insufficient Balance Error Message'));
          setPayLoading(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setPayLoading(false);
        return;
      }

    }
    catch(e)
    {
      setErrorMessage(t('User Reject Request Error Message'));
      isSuccess = false;
      setPayLoading(false);
      return;
    }
    if (isSuccess) {
      setShow(false);
      toast.success(t('Success!'));
    }
    setPayLoading(false);
  }

  return (
    <>
      <div 
        className="flex flex-row gap-1 items-center rounded-md cursor-pointer py-2 px-4 border-gray-500 border-[1px] border-solid justify-center" 
        onClick={() => handleShow()}
      >
        <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="9" fill="#e91d9b"></circle><path d="M13.14 7.965c.185-1.143-.624-1.672-1.078-1.964-.452-.292-1.143-.502-1.143-.502l.442-1.78-1.02-.256-.442 1.78-.815-.206.442-1.78L8.494 3l-.442 1.78-2.157-.542-.262 1.056s1.065.266 1.182.297c.12.029.104.09.094.13-.01.04-1.34 5.405-1.36 5.476-.016.072-.028.113-.127.09l-1.131-.284L4 12.176l2.088.523-.423 1.702 1.113.279.423-1.703.693.174-.423 1.703 1.06.266.424-1.702.798.2c.53.133 2.544.158 2.982-1.611.439-1.77-1.012-2.519-1.012-2.519s1.23-.38 1.417-1.523Zm-2.417 3.282c-.21.847-1.155.912-1.37.857l-1.895-.474.56-2.262 1.965.492c.377.096.951.54.74 1.387Zm.35-3.445c-.224.902-1.124.861-1.408.791L8.28 8.246l.534-2.153 1.264.316c.216.054 1.22.492.995 1.393Z" fill="#fff"></path></svg>
        <span className = "md:mt-[1px] mt-[2px] font-bold text-primary hover:text-primary-hover">
          {t('SAFE BTC TRANSFER')}
        </span>
      </div>
      <Dialog
          open={show}
          size={"sm"}
          className="bg-black border-solid border-[1px] border-gray-600"
        >
        <DialogBody>
          <div className = "flex flex-col gap-4 md:p-4 p-1">
            <div className = "m-auto">
              <img src={logoImg} alt="Logo Img" className="md:w-20 w-14 md:h-20 h-14"/>
            </div>
            <div className="text-primary font-bold md:text-[32px] text-[24px] text-center mb-4">{t('SAFE BTC TRANSFER')}</div>
            <div>
              <Input type="text" color="white" label = {t('Recipient')} className="w-full md:min-w-[500px] min-w-[250px]" value={address} onChange = {(e) => {setAddress(e.target.value)}}/>
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-row justify-end text-primary cursor-pointer font-bold" onClick={() => handleSetIsAll()}>{t('MAX')}</div>
              <Input type="text" color="white" label = {t('Insert Transfer Amount')} className="w-full md:min-w-[500px] min-w-[250px]" value={amount} onChange = {(e) => {setAmount(e.target.value)}}/>
            </div>
            {
              loading ?
              <div className="m-auto">
                <Spinner className="h-16 w-16 text-gray-900/50" color="pink"/>
              </div>
              :
              <div className="flex flex-row justify-between">
                <div className="font-bold text-primary">{t('Available')}</div>
                <div className="text-white">{available} BTC</div>
              </div>
            }
            <div className="grid grid-cols-3 gap-3">
              <FeeRateCardNew header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
              <FeeRateCardNew header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
              <FeeRateCardNew header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
            </div>
            {
              feeRateMode == "Custom" ? 
              <div>
                <Slider color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
              </div>
              : 
              <></>
            }
            {
              errorMessage != '' ? 
              <div className="flex flex-row gap-1 items-center">
                <ExclamationCircleIcon strokeWidth={3} className="h-6 w-6 text-red-700"/>
                <div className="text-red-700 font-bold">{errorMessage}</div>
              </div>
              : <></>
            }
            {
              payLoading ?
              <div className="m-auto">
                <Spinner className="h-16 w-16 text-gray-900/50" color="pink"/>
              </div>
              :
              <div className="flex flex-row gap-4 justify-center mt-4">
                <div className="md:px-[52px] px-[32px] py-2 font-bold rounded-md text-white bg-primary cursor-pointer" onClick={() => handlePay()}>{t('SEND')}</div>
                <div 
                  className="md:px-[40px] px-[20px] py-2 font-bold rounded-md text-white bg-gray-800 cursor-pointer" 
                  onClick={(e) => handleHide(e)}>
                  {t('CANCEL')}
                </div>
              </div>
            }
          </div>
        </DialogBody>
      </Dialog>
    </>
  )
}
